import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';

// helper
import { BaseError } from '../../helpers/BaseError';

// models
import {
    CMSFilterModel,
    CMSFilterCreateModel,
} from '../../models/cms-placeholder.model';

// API
import API from '../../services/api';

import formulaKeys from './_queryKeys';

export default function useFormulaCMSFiltersMutation(formulaId: number) {
    const queryClient = useQueryClient();

    return useMutation<
        AxiosResponse<{
            cms_placeholder_filters: CMSFilterModel[];
        }>,
        BaseError,
        {
            cms_placeholder_filters: CMSFilterCreateModel[];
            formula_id?: number;
            message_content_id?: string;
        }
    >({
        mutationFn: (data: {
            cms_placeholder_filters: CMSFilterCreateModel[];
            formula_id?: number;
            message_content_id?: string;
        }) => {
            const id = formulaId || data.formula_id;
            if (data.formula_id) {
                delete data.formula_id;
            }
            return API.updateFormulaCMSFilters(id, data);
        },

        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: formulaKeys.all });
            queryClient.invalidateQueries({
                queryKey: formulaKeys.formulaById(formulaId),
            });
        },
    });
}
